<template>
    <div>
        <Header/>
        <Content/>
    </div>    
</template>

<script>
import Content from './Content.vue'
import Header from './Header.vue'

export default {
  name: 'Homepage',
  components: {
    Header,
    Content,
  }
}
</script>
